/* VÉLOR SKIN: Shopify product variants + Ajax cart with live variant validation. */
(()=>{
  'use strict';
  const formatMoney=(cents,currency)=>{
    try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{
      style:'currency',currency:currency||'USD'
    }).format(Number(cents)/100)}
    catch{return '$'+(Number(cents)/100).toFixed(2)}
  };

  function mount(root){
    if(root.dataset.vpdpReady==='1')return;
    root.dataset.vpdpReady='1';
    const $=(s,c=root)=>c.querySelector(s);
    const $$=(s,c=root)=>[...c.querySelectorAll(s)];
    const bundles=$$('[data-vpdp-bundle]');
    const radios=$$('[data-vpdp-radio]');
    const add=$('[data-vpdp-add]');
    const message=$('[data-vpdp-feedback]');
    const total=$('[data-vpdp-total]');
    const main=$('[data-vpdp-main-image]');
    const thumbs=$$('[data-vpdp-thumb]');
    if(!bundles.length||!add||!message||!total)return;
    let photoIndex=0;
    const prefix=(root.dataset.root||'/').replace(/\/$/,'')+'/';
    const productHandle=(root.dataset.productHandle||'').trim();
    const showBundleOffers=(root.dataset.bundleOffers==='true');
    const activeBundle=()=>bundles.find(b=>b.querySelector('[data-vpdp-radio]')?.checked)||bundles[0];
    const report=(text,isError=true)=>{
      message.textContent=text;
      message.classList.toggle('is-error',isError);
    };
    function displayImage(i){
      if(!thumbs.length||!main)return;
      photoIndex=(i+thumbs.length)%thumbs.length;
      const selected=thumbs[photoIndex];
      main.src=selected.dataset.image;
      main.alt=selected.dataset.alt||'VÉLOR SKIN';
      thumbs.forEach((t,j)=>{
        t.classList.toggle('is-active',j===photoIndex);
        t.setAttribute('aria-pressed',String(j===photoIndex));
      });
      selected.scrollIntoView?.({block:'nearest',inline:'nearest',behavior:'auto'});
    }
    thumbs.forEach((button,i)=>button.addEventListener('click',()=>displayImage(i)));
    $('[data-vpdp-prev]')?.addEventListener('click',()=>displayImage(photoIndex-1));
    $('[data-vpdp-next]')?.addEventListener('click',()=>displayImage(photoIndex+1));

    function update(preserveMessage=false){
      const active=activeBundle();
      bundles.forEach(bundle=>{
        const on=bundle===active;
        bundle.classList.toggle('is-selected',on);
        const content=$('[data-vpdp-choices]',bundle);
        if(content)content.hidden=!on;
        $$('[data-vpdp-select]',bundle).forEach(s=>s.disabled=!on);
      });
      let valid=true;
      let activePricing=null;
      bundles.forEach(bundle=>{
        const selectedOptions=$$('[data-vpdp-select]',bundle).map(s=>s.selectedOptions[0]);
        const prices=[];
        let compare=0;
        selectedOptions.forEach(option=>{
          const selectedPrice=Number(option?.dataset.price||0);
          const listedCompare=Number(option?.dataset.compare||0);
          prices.push(selectedPrice);
          compare+=listedCompare>selectedPrice?listedCompare:selectedPrice;
          if(bundle===active&&(!option||option.disabled||!option.value))valid=false;
        });
        const regularSubtotal=prices.reduce((sum,v)=>sum+v,0);
        const bundleSize=selectedOptions.length;
        // Shopify Buy X Get Y discounts on the same product discount the
        // lowest-priced qualifying items. All 6 fragrances should normally
        // share a $30.00 selling price for $60/$90 advertised bundle totals.
        const paidCount=showBundleOffers ? (bundleSize===3?2:bundleSize===5?3:bundleSize) : bundleSize;
        const promotionalTotal=[...prices].sort((a,b)=>b-a).slice(0,paidCount).reduce((sum,v)=>sum+v,0);
        const priceEl=$('[data-vpdp-bundle-price]',bundle);
        if(priceEl)priceEl.textContent=formatMoney(promotionalTotal,root.dataset.currency);
        const compareEl=$('[data-vpdp-bundle-compare]',bundle);
        if(compareEl){
          compareEl.hidden=!(compare>promotionalTotal);
          compareEl.textContent=compare>promotionalTotal?formatMoney(compare,root.dataset.currency):'';
        }
        if(bundle===active)activePricing={bundleSize,regularSubtotal,promotionalTotal};
      });
      const slots=$$('[data-vpdp-select]',active);
      const pricing=activePricing||{bundleSize:0,regularSubtotal:0,promotionalTotal:0};
      if(showBundleOffers&&pricing.bundleSize>1){
        total.textContent=`${pricing.bundleSize} jars selected · ${formatMoney(pricing.promotionalTotal,root.dataset.currency)} with eligible Shopify discount (${formatMoney(pricing.regularSubtotal,root.dataset.currency)} before bundle discount)`;
      }else{
        total.textContent=`${pricing.bundleSize} ${pricing.bundleSize===1?'jar':'jars'} selected · ${formatMoney(pricing.regularSubtotal,root.dataset.currency)}${pricing.bundleSize>1?' before applicable discounts':''}`;
      }
      add.disabled=!valid;
      if(!valid)report('Choose an available fragrance for every jar.');
      else if(!preserveMessage)report('',false);
    }
    radios.forEach(r=>r.addEventListener('change',()=>update()));
    $$('[data-vpdp-select]').forEach(s=>s.addEventListener('change',()=>{
      update();
      const option=s.selectedOptions[0];
      if(!option?.dataset.image)return;
      const i=thumbs.findIndex(t=>t.dataset.image===option.dataset.image);
      if(i!==-1)displayImage(i);
      else if(main){main.src=option.dataset.image;main.alt=option.dataset.label||'VÉLOR SKIN fragrance'}
    }));
    const checkbox=$('[data-vpdp-subscribe]');
    const planWrap=$('[data-vpdp-plan-wrap]');
    checkbox?.addEventListener('change',()=>{if(planWrap)planWrap.hidden=!checkbox.checked});

    /* Shopify /products/{handle}.js is the online-store source of truth for purchasable variants.
       Checking before /cart/add.js prevents submitting obsolete or unpublished IDs. */
    async function verifyLiveVariants(slots){
      if(!productHandle)throw new Error('Product is not configured. Please contact the store.');
      const url=prefix+'products/'+encodeURIComponent(productHandle)+'.js';
      const response=await fetch(url,{
        method:'GET',credentials:'same-origin',cache:'no-store',
        headers:{'Accept':'application/json'}
      });
      if(!response.ok){
        throw new Error('This product cannot be purchased from the Online Store right now. Please check that it is published, or contact support.');
      }
      let data;
      try{data=await response.json()}catch{throw new Error('Unable to verify this product. Please refresh the page and try again.')}
      if(!Array.isArray(data?.variants))throw new Error('Shopify did not return the product variants. Please refresh and try again.');
      const variants=new Map(data.variants.map(v=>[String(v.id),v]));
      const selected=[];
      for(const select of slots){
        const option=select.selectedOptions[0];
        if(!option||option.disabled||!option.value){
          throw new Error('Please choose an available fragrance for each jar.');
        }
        const id=String(option.value);
        const variant=variants.get(id);
        const label=option.dataset.label||option.textContent.trim();
        if(!variant){
          throw new Error(`The ${label} variant is no longer listed on Shopify. Refresh the page and select the scent again.`);
        }
        if(variant.available===false){
          throw new Error(`${label} is currently sold out or unavailable for online purchase. Please choose another scent.`);
        }
        const numericId=Number(id);
        if(!Number.isSafeInteger(numericId)||numericId<=0){
          throw new Error('The fragrance ID is invalid. Please refresh the page.');
        }
        selected.push({id:numericId,label});
      }
      return selected;
    }

    $('[data-vpdp-form]')?.addEventListener('submit',async event=>{
      event.preventDefault();
      if(add.disabled)return;
      const slots=$$('[data-vpdp-select]',activeBundle());
      add.disabled=true;
      const originalLabel=add.innerHTML;
      add.textContent='CHECKING AVAILABILITY…';
      report('',false);
      try{
        const selected=await verifyLiveVariants(slots);
        const sellingPlan=(checkbox?.checked&&$('[data-vpdp-plan]')?.value)||null;
        const byVariant=new Map();
        for(const entry of selected){
          byVariant.set(entry.id,(byVariant.get(entry.id)||0)+1);
        }
        const items=[...byVariant].map(([id,quantity])=>{
          const line={id,quantity};
          if(sellingPlan)line.selling_plan=Number(sellingPlan);
          return line;
        });
        add.textContent='ADDING TO CART…';
        const response=await fetch(prefix+'cart/add.js',{
          method:'POST',credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items})
        });
        let data={};
        try{data=await response.json()}catch{}
        if(!response.ok){
          const raw=String(data.description||data.message||'');
          if(/cannot find variant|variant not found|couldn.t find variant/i.test(raw)){
            throw new Error('Shopify could not find one of the chosen fragrances. Please confirm the variants are available in your store and refresh this page.');
          }
          throw new Error(raw||`Unable to add to cart (${response.status})`);
        }
        report(`Added ${slots.length} ${slots.length===1?'jar':'jars'} to your bag. Check the Shopify cart or checkout to confirm the advertised automatic bundle discount was applied.`,false);
        const cartButton=document.querySelector('[data-open-cart]');
        if(cartButton)cartButton.click();
        else window.location.assign(prefix+'cart');
      }catch(err){
        report(err?.message||'Sorry, the cart could not be updated.');
      }finally{
        add.innerHTML=originalLabel;
        update(true);
      }
    });
    update();
  }
  function boot(){document.querySelectorAll('[data-vpdp]').forEach(mount)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',boot);
})();
